// extracted by mini-css-extract-plugin
module.exports = {"guide_share":"inviteSuccess_guide_share__GNTGc","btn":"inviteSuccess_btn__2VF9O","mask":"inviteSuccess_mask__38DYK"};